var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-link',{on:{"click":_vm.upload_photo_id}},[_vm._v(" Upload Photo ID ")])
}
var staticRenderFns = []

export { render, staticRenderFns }